import {ButtonGroup} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {matchesStatusTab} from '../utils';

import type {TeamStatusTab} from '../types';
import type {FirmMemberDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface TeamStatusTabsProps {
  /**
   * The full roster, already narrowed to `countableTeamMembers` — counts always reflect
   * every member (minus Sollapay-managed accounts), never the search/filter result.
   */
  countableMembers: FirmMemberDTO[];
  value: TeamStatusTab;
  onValueChange: (value: TeamStatusTab) => void;
}

const STATUS_TABS: readonly TeamStatusTab[] = ['all', 'active', 'pending'];

export const TeamStatusTabs: FC<TeamStatusTabsProps> = ({
  countableMembers,
  value,
  onValueChange
}) => {
  const {t} = useTranslation('team');

  const items = STATUS_TABS.map(tab => ({
    value: tab,
    label: t(`statusTabs.${tab}`),
    badge: countableMembers.filter(member => matchesStatusTab(member, tab)).length
  }));

  return (
    <ButtonGroup
      items={items}
      value={value}
      onChange={val => onValueChange(val as TeamStatusTab)}
    />
  );
};
